<template>
<b-container>
    <b-alert :show = "showDismissibleAlert" dismissible 
            @dismissed="showDismissibleAlert=false"
            :variant="variant">
            {{alertText}}
    </b-alert>
    <Spinner size="32" message="Loading..." v-if="isLoading"> </Spinner>
    <b-form @submit="onSubmit" @reset="onReset">
        <b-row class="mt-2">
            <b-col>
                <b-form-group id="exampleInputGroup2" horizontal="" label-cols="6"
                        label="Enter Registered Mobile Number*" label-size="sm"
                        label-for="inpmobile">
                    <b-form-input id="inpmobile"
                        type="tel"
                        v-model="form.mobile"
                        required size="sm"
                        placeholder="10 digit Mobile Number"></b-form-input>    
                </b-form-group>
            </b-col>
        </b-row>
        <b-row class="mt-2">
            <b-col md="12" sm="12" style="text-align:right">
            <b-button type="submit" size="sm" variant="primary">Submit</b-button>
            <b-button type="reset" size="sm" variant="danger">Cancel</b-button>
            </b-col>
        </b-row>
    </b-form>
</b-container>
</template>

<script>
import apis from "@/apis";
import Spinner from "vue-simple-spinner";
export default {
  computed: {
    mobileNumber() {
      var phoneno = /^\d{10}$/;
      if (this.form.mobile) {
        if (this.form.mobile.match(phoneno)) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
  },
  data() {
    return {
      form: {
        registrationType: "",
        FirstName: "",
        MiddleInitial: "",
        LastName: "",
        UserName: "",
        EmailID: "",
        Mobile: "",
        Password: ""
      },
      show: true,
      alertText: "",
      showDismissibleAlert: false,
      variant: "success",
      isLoading: false
    };
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      if (!this.mobileNumber) {
        this.alertText = "Please verify the mobile number";
        this.variant = "warning";
        this.showDismissibleAlert = true;
        this.isLoading = false;
        return;
      }

      let promise = apis.frgot(this.form);

      promise
        .then(response => {
          //console.log("Reponse", response);
          if (response.status == 200) {
            //chck message
            this.alertText =
              "If your are registered with us, you will receive a SMS with Login details.";

            this.showDismissibleAlert = true;
            this.isLoading = false;
            //this.$router.push("/");
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
        })
        .catch(err => {
          this.alertText = err.body;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
      //this.$emit("close");
    },
    onReset(evt) {
      evt.preventDefault();
      this.$emit("close");
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/ForgotPassword.vue